<template>
  <v-container class="search">
    <h1 class="mt-12 mb-6">Showing search results for ""</h1>
    <v-container>
      <Grid ref="gridComponent" />
      <!-- TODO -->
      <!-- <v-tabs fixed-tabs background-color="#f6f3e5" class="mb-6">
        <v-tab>Newest</v-tab>
        <v-tab>Popular</v-tab>
        <v-tab>Clubs</v-tab>
      </v-tabs> -->
    </v-container>
    <v-row justify="center" class="mt-8">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            @click="previous"
            :disabled="previousDisabled"
            color="primary"
            fab
            x-large
            dark
            class="mr-6"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </template>
        <span>Previous results</span>
      </v-tooltip>

      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            @click="next"
            :disabled="nextDisabled"
            color="primary"
            fab
            x-large
            dark
            class="ml-6"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </template>
        <span>Next results</span>
      </v-tooltip>
    </v-row>
  </v-container>
</template>

<script>
import Grid from "../components/Grid";

export default {
  name: "Search",
  components: {
    Grid,
  },
  data: () => ({
    previousDisabled: false,
    nextDisabled: false,
  }),
  methods: {
    next() {
      this.$refs.gridComponent.paginateNext();
    },
    previous() {
      this.$refs.gridComponent.paginatePrevious();
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  text-align: center;
  h1 {
    font-family: "Playfair Display";
    font-weight: 900;
    font-size: 3.5rem;
    @media screen and (max-width: 800px) {
      line-height: 3rem;
      font-size: 2.2rem;
    }
  }

  h2 {
    font-family: "Playfair Display";
  }
}
</style>
